import { createContext, useContext, useState, ReactNode } from 'react';

type Campus = 'Vellore' | 'Chennai' | 'AP';

interface CampusContextType {
  campus: Campus;
  setCampus: (campus: Campus) => void;
}

const CampusContext = createContext<CampusContextType | undefined>(undefined);

export const CampusProvider = ({ children }: { children: ReactNode }) => {
  const [campus, setCampus] = useState<Campus>('Vellore');

  return (
    <CampusContext.Provider value={{ campus, setCampus }}>
      {children}
    </CampusContext.Provider>
  );
};

export const useCampus = () => {
  const context = useContext(CampusContext);
  if (!context) {
    throw new Error('useCampus must be used within a CampusProvider');
  }
  return context;
}; 